import { makeStyles } from '@fluentui/react-components';

export const useReportDetailPageStyles = makeStyles({
  separatorLineStyle: {
    borderLeft: '1px solid #E0E0E0',
    height: '32px',
  },
  dataActionRightSideStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  dataActionLeftSideStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },
  dataActionContainerStyle: {
    borderTop: '1px solid #d2d0ce',
    borderBottom: '1px solid #d2d0ce',
    alignItems: 'center',
    display: 'flex',
    padding: '10px',
    justifyContent: 'space-between',
  },
  reportActionContainerStyle: {
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    minWidth: 0,
    gap: '8px',
  },
  detailPageContainerStyle: {
    padding: '24px 32px',
    gridRowGap: '9px',
    width: '100%',
  },
  reportActionStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  dropdownStyle: {
    minWidth: 0,
    width: 'fit-content',
    padding: '6px',
  },
  hover: {
    cursor: 'pointer',
  },
  reportTitleContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
    flex: '1',
  },
  reportTitleStyle: {
    overflow: 'hidden',
    lineHeight: '1.2',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flexShrink: '1',
  },
  dialogContentStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  schedulePanelBody: {
    margin: '0px 32px',
    padding: '0px 24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderLeft: '1px solid #d2d0ce',
    minWidth: 0,
    flex: 1,
  },
  schedulePanelItem: {
    gap: '4px',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    flex: 1,
  },
});
